export default __webpack_public_path__ + "static/media/logo-toogether-white.b28f2f07.svg";